// extracted by mini-css-extract-plugin
export default {"popup":"WarningPopup_popup__Y1A8H","message_section":"WarningPopup_message_section__ErFIi"};